export enum RouteKeys {
  Auth = '/auth',
  Login = '/auth/login',
  Signup = '/signup',
  SignupOtp = '/signup/otp',
  SignupOnboard = '/signup/onboard',
  SignupThankYou = '/signup/thank-you',
  Home = '/',
  Dashboard = '/dashboard',
  ForgotPassword = '/auth/forgot-password',
  ResetPasswordWithOTP = '/auth/forgot-password/otp',
  Payment = '/dashboard/payment',
  PaymentCallback = '/payment/redirect',
  NotFound = '/page-not-found',
  LectureVideo = '/lecture-video/:lessonId/:topicId/:subTopicId',
  ScheduleDetails = '/schedules/:scheduleId',
  QuestionAnswer = '/question-answer/:lessonId/:topicId/quiz',
  PdfInvoice = '/invoice/:id/pdf/',
  PdfCrmInvoice = '/crm-invoice/:id/pdf/',
  LumpsumPdfInvoice = '/lumpsum-invoice/pdf/',
  PdfContract = '/contract/:id/pdf/',
  Dev = '/dev/',
  PdfRefundDocument = '/refund-document/:id/pdf/',
  PdfClearanceCertificate = '/clearance-certificate/:id/pdf/',
  PdfTransferCertificate = '/transfer-certificate/:id/pdf/',
  BookAppointment = '/book-an-appointment',
  BookAppointmentThankYou = '/book-an-appointment/thank-you',
  PaymentThankYou = '/dashboard/payment/thank-you',
  CustomerFeedback = '/customer-feedback',
  CustomerFeedbackThankYou = '/customer-feedback-thank-you',
  CorporateLumpsumPdfInvoice = '/corporate-lumpsum-invoice/pdf/',
  CorporatePdfInvoice = '/corporate-invoice/pdf/',
  PdfRefundDocumentCorporate = '/corporate-refund-document/:id/pdf/',
  PreregistrationPdfInvoice = '/preregistration-invoice/:id/pdf/',
  PreregistrationPdfCrmInvoice = '/preregistration-crm-invoice/:id/pdf/',
  MyReferrals = '/dashboard/my-referral-report/:id/',
  EditProfile = '/dashboard/profile/edit-profile',
  SalesmanCollectionReport = '/saleman-collection-report/pdf/',
  SalesmanCollectingReport = '/saleman-collecting-report/pdf/',
  CollectionReportPdf = '/collection-report/pdf/',
  QuickSignup = '/quick-signup',
  PaymentError = '/dashboard/payment/error',
  OnlinePaymentRedirect = '/payment/redirect',
  SignupPaymentError = '/signup/payment-error',
  SalesmanAllCollectionReport = '/saleman-all-collection-report/pdf/',
  RegAdditionalPaymentCallback = '/payment/v1/web-hook/payment-handler',
  AdditionalPaymentCallback = '/payment/v1/web-hook/additional-payment-handler',
  MockTestOtp = '/mock-test',
  OnlinePaymentRedirectForLink = '/payment/redirectlink',
  PaymentErrorLink = '/dashboard/paymentlink/error',
  PaymentCancelledLink = '/dashboard/paymentlink/cancelled',
  PaymentThankYouLink = '/dashboard/paymentlink/success',
  PaymentRequestPage = '/payment-request/:id',
  EliteAdditionalPaymentCallback = '/payment/v1/web-hook/elite-additional-payment-handler',
  ContractRequestPageOtp = '/contract-request/id/:id',
  CashierAllCollectionReport = '/cashier-all-collection-report/pdf/',
  CashierCollectingReport = '/cashier-collecting-report/pdf/',
  OnlineWebhookPaymentRedirect = '/payment/redirectOnlinePayment',
  CorporateSummaryPdfInvoice = '/corporate-summary-invoice/pdf/',
  LectureHallMockTest = '/lecture-hall-mock-test',
  TrainingCenterTheoryTest = '/training-center/theory-test',
  PdfTrainingCompletionCertificate = '/training-completion-certificate/:id/pdf/',
  TrainingCenterDashboard = '/training-center/dashboard',
}
